var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuPlus = function SvgMenuPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 112.27 112.27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m89.62 48.07-27.11.49.78-26.08-12.86.72-.74 25.52-24.49.44-2.54 14.68 26.76-1.86-.8 27.82 12.86-2.91.76-25.52 27.38-1.9z"
  })));
};
export default SvgMenuPlus;